module.exports = __webpack_public_path__ + "img/TAmbience.8a79267e.png";